import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { LoaderService } from './loader.service';

@Component({
    selector: 'app-loader',
    imports: [AsyncPipe, MatProgressSpinner],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent {
  private loaderService = inject(LoaderService);

  loading$ = this.loaderService.isLoading$;
}
